module.exports = __webpack_public_path__ + "908e4d2e/img/share-icon.0f8a11b4.svg";